/* eslint semi:            ["error", "never"]*/

/* eslint arrow-parens:    ["error", "as-needed"]*/

/* eslint key-spacing:     ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import React from 'react';
import ReminderSetting from '@engine/components/presentational/merchant-reminders-config/reminder-setting';
import { ordinal } from '@engine/lib/utility/ordinal';

var ReminderSettings = function ReminderSettings(_ref) {
  var remindersCount = _ref.remindersCount,
      maxRemindersAllowed = _ref.maxRemindersAllowed,
      remindersSettings = _ref.remindersSettings,
      _onChange = _ref.onChange;
  var count = parseInt(remindersCount, 10) || 0;

  if (count <= 0 || count > maxRemindersAllowed) {
    return null;
  }

  var reminderArray = Array.from(Array(count + 1).keys()).slice(1);
  return React.createElement("div", null, reminderArray.map(function (number) {
    return React.createElement(ReminderSetting, {
      key: number,
      channel: remindersSettings["".concat(ordinal(number), "_channel")],
      minutes: remindersSettings["".concat(ordinal(number), "_after")],
      onChange: function onChange(name, value) {
        return _onChange(name, value);
      },
      reminder: number
    });
  }));
};

export default ReminderSettings;